import React, {useEffect} from 'react';
import ReportViewer from "../../rapports/base/ReportViewer";
import {Popup} from "devextreme-react/popup";
import Guid from "../../models/Guid";
import {useParams} from "react-router-dom";
import RenderInNewWindow from "../../utils/RenderInNewWindow";

interface IImpressionConfirmationProps {
    idReservationEntete: Guid,
    idMessage?: Guid,
    onClose: () => void
}

const ImpressionConfirmation = ({idReservationEntete, idMessage, onClose}: IImpressionConfirmationProps) => {

    return (
        <RenderInNewWindow onClose={onClose}>
            <div style={{display: "flex", justifyContent: "center", flex: 1}}>
                <ReportViewer reportName={`ConfirmationLettreReport/${idReservationEntete}/${idMessage}`}/>
            </div>
        </RenderInNewWindow>
    );
}
export default ImpressionConfirmation;